import axios from 'axios';
import { Message } from 'element-ui';
import { delay } from '@/utils/utils.js';
import NProgress from 'nprogress';
import Lockr from 'lockr';
import { saveAs } from 'file-saver';

const siteName = process.env.VUE_APP_SITE_NAME;
const isDev = process.env.NODE_ENV === 'development';
const headers = {};
axios.defaults.baseURL = isDev ? '/api' : '/newfib.php';
// axios.defaults.timeout = process.env.TIMEOUT || 10000; // 响应时间

headers['Content-Type'] = 'application/json';
headers['X-Requested-With'] = 'XMLHttpRequest';
headers['X-Site-Name'] = siteName;

Lockr.prefix = `${process.env.VUE_APP_SITE_NAME}_`;

headers['X-Jwt-Token'] = Lockr.get('jwt') || '';
headers['X-Client-Language'] = Lockr.get('local') || 'zh';
headers['X-Is-Dev'] = Number(isDev);

const instance = axios.create({
  headers,
  // withCredentials: true, // 允许跨域 cookie
  validateStatus(status) {
    return (status >= 200 && status < 300) || (status > 400 && status < 500); // 获取服务端异常
  },
});

const { Promise } = require('es6-promise');

instance.requestCount = 0;

instance.interceptors.request.use((config) => {
  config.headers['X-Intenal-Ip'] = Lockr.get('internal_ip');
  const oldFibOps = config.url.indexOf('system.php');
  if (oldFibOps > -1) {
    config.baseURL = '/';
    config.url = config.url.substr(oldFibOps);
  }
  instance.requestCount++;
  return config;
}, (error) => {
  return Promise.reject(error);
});

export function _isMobile() {
  let flag = navigator.userAgent.match(/(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i);
  return flag;
}

function getLoginUrl() {
  if (siteName === 'fib') {
    if (_isMobile() && isDev) {
      return '/frontend/h5/tools';
    }
    return '/frontend/login';
  }
  return '/login';
}
instance.interceptors.response.use((response) => {
  if (response.data.result === -1) {
    if (response.data.code === 4001 || response.data.code === 4002) { // 未登录
      window.location.href = getLoginUrl();
    } else if (response.data.code === 4003) { // 未授权访问
      // window.loading.close();
      if (window.history.length > 1) {
        Message.error('无权限访问该页面');
        delay(0.5).then(() => {
          window.history.back();
        });
      } else {
        window.location.href = '/system.php/Student/custom';
      }
      const errorText = `NO PERMISSION: ${response.config.url} ${JSON.stringify(response.config.params)}`;
      console.warn(errorText);
      return Promise.reject(new Error(errorText));
    } else if (response.data.code === 4005) {
      Message.error({
        message: response.data.msg ||
          ((typeof response.data.data === 'string') ? response.data.data : ''),
        duration: 0,
        showClose: true,
      });
    } else {
      Message.error(response.data.msg ||
          ((typeof response.data.data === 'string') ? response.data.data : ''));
    }
    // 后端异常
    if (response.status > 400) {
      delay(0.3).then(() => {
        window.history.back();
      });
    }
    return Promise.reject(response);
  }

  instance.requestCount--;
  if (instance.requestCount === 0) {
    // window.loading.close();
  }
  return response.data;
}, (error) => {
  Message.error('请刷新重试');
  // window.loading.close();
  return Promise.reject(error);
});


export default instance;
// get
export const _get = (req) => {
  if (typeof req === 'string') {
    return instance.get(req);
  }
  return instance.get(req.url, { params: req.data, ...(req.config || {}) });
};

// put
export const _put = req => instance.put(req.url, req.data, req.config || {});

// post
export const _post = req => instance.post(req.url, req.data, req.config || {});

// delete
export const _delete = req => instance.delete(req.url, req.config || {});

// 该方法可能只适用于蓝火FIB， 考培training不适用
export const _download = (req) => {
  let downloadUrl = `${axios.defaults.baseURL}/index/base/downloadFile`;
  downloadUrl = `${downloadUrl}/filename/${req.filename}/download/${req.download}`;
  window.location.href = downloadUrl;
};

export function downloadUrl(url, name = 'download') {
  const link = document.createElement('a');
  link.href = url;
  link.target = '_blank';
  link.setAttribute('download', name);
  document.body.appendChild(link);
  link.click();
  link.remove();
}

export function downloadFileByResponse(res, name) {
  const url = window.URL.createObjectURL(new Blob([res]));
  downloadUrl(url, name);
}

export const downloadFile = (req) => {
  NProgress.start();
  return instance.post(
    req.url,
    req.data || [],
    {
      responseType: 'blob',
    }
  ).then((response) => {
    downloadFileByResponse(response, req.filename);
    NProgress.done();
  }).catch((e) => {
    console.log(e);
    NProgress.done();
    Message.error('Download Fail');
  });
};

export const getFile = ({ url, filename }) => {
  NProgress.start();
  return instance.get(
    url,
    {
      responseType: 'blob',
      baseURL: '/',
    }
  ).then((response) => {
    downloadFileByResponse(response, filename);
    NProgress.done();
  }).catch((err) => {
    NProgress.done();
    console.error(err);
    Message.error('文件下载失败');
  });
};

export function saveFile(file, filename = null, optional = {}) {
  return saveAs(file, filename, optional);
}
